"use client"
import React, { createContext, useContext, useEffect, useMemo, useState } from "react"

const ThemeCtx = createContext(null)

export function ThemeProvider({ children, storageKey = "pg_theme", defaultTheme = "system" }) {
  const [theme, setTheme] = useState(defaultTheme) // "light" | "dark" | "system"

  useEffect(() => {
    try {
      const saved = localStorage.getItem(storageKey)
      if (saved) setTheme(saved)
    } catch {}
  }, [storageKey])

  useEffect(() => {
    const root = document.documentElement
    const systemPrefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches

    const effective = theme === "system" ? (systemPrefersDark ? "dark" : "light") : theme

    root.classList.remove("light", "dark")
    root.classList.add(effective)
    if (effective === "dark") root.classList.add("dark")
    else root.classList.remove("dark")

    try { localStorage.setItem(storageKey, theme) } catch {}
  }, [theme, storageKey])

  const value = useMemo(() => ({
    theme,
    setTheme,
    toggleTheme: () => setTheme(t => (t === "dark" ? "light" : "dark")),
  }), [theme])

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>
}

export function useTheme() {
  const ctx = useContext(ThemeCtx)
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider")
  return ctx
}
